"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const pattern_library_utils_price_format_1 = require("@saatva-bits/pattern-library.utils.price-format");
const line_item_1 = __importDefault(require("../line-item"));
const accordion_1 = __importDefault(require("../accordion"));
const styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
const MRCTaxLine = ({ mrc, variant = 'cart' }) => {
    if (variant === 'cart' || variant === 'confirmation') {
        return ((0, jsx_runtime_1.jsx)(line_item_1.default, { label: "State Recycling Fee", value: (0, pattern_library_utils_price_format_1.formatToCurrency)(mrc), dataSelector: "orderSummary_mrc" }));
    }
    // Checkout variant with dropdown
    return ((0, jsx_runtime_1.jsx)(accordion_1.default, { label: 'State Recycling Fee', amount: (0, pattern_library_utils_price_format_1.formatToCurrency)(mrc), className: styles_module_scss_1.default.acordion, dataSelector: "orderSummaryMRCTotal", children: (0, jsx_runtime_1.jsx)("p", { className: styles_module_scss_1.default.message, children: "Based on state laws in CA, CT, OR & RI, we are required to collect a recycling fee for every mattress or foundation sold." }) }));
};
MRCTaxLine.propTypes = {
    mrc: prop_types_1.default.number.isRequired,
    variant: prop_types_1.default.oneOf(['cart', 'checkout'])
};
exports.default = MRCTaxLine;
//# sourceMappingURL=index.js.map